<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-container class="toolbar__container">
            <v-form ref="form" v-model="formValidado">
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <MultiplaEscolha :items="unidadesItens" v-bind:selected-items.sync="unidadesSelecionadas"
                            text="descricao_unidade" value="id_unidade" :label="$t('nav.registration.units')"
                            :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="6" md="5">
                        <MultiplaEscolha :items="linhasItens" v-bind:selected-items.sync="linhasSelecionadas"
                            text="nome_linha" value="id_linha" :label="$t('nav.registration.lines')" :max-items="2" />
                    </v-col>
                    <v-col cols="12" sm="1" md="2" align="center" style="align-self: center;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="setDefaultFilters" style="margin-left: 10px; margin-bottom: 5px;">
                                    <v-icon>mdi-refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.newConsult') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable item-key="id" :headers="tableHeaders" :items="itens" :loading="loading"
            :default-multi-sort="defaultSort" :loading-text="$t('relOcupacaoTurno.loading')"
            cod-tabela="RELOCUPACAOTURNO" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('relOcupacaoTurno.title')" :token="token" :items="itens"
                    csv-title="ocupacaoporturno" :csv-headers="exportHeadersResolved"
                    list-endpoint="getrelatorioocupacaoporturno" :request-params="csvExportRequestParams"
                    :export-total="itens.length"
                    :pdf-title="$t('relOcupacaoTurno.title')" :pdf-headers="exportHeadersResolved"
                    pdf-filename="ocupacaoporturno" hide-search>
                </CadastroToolbar>
            </template>
            <template v-slot:item.taxa_ocupacao="{ item }">
                {{ item.taxa_ocupacao != null ? `${item.taxa_ocupacao}%` : '' }}
            </template>
            <template v-slot:item.taxa_ocupacao_prevista="{ item }">
                {{ item.taxa_ocupacao_prevista != null ? `${item.taxa_ocupacao_prevista}%` : '' }}
            </template>
        </MerusDataTable>
    </v-container>
</template>

<script>

import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import apiController from '@/utils/apiController';
import MerusDataTable from "../components/Tables/MerusDataTable.vue";
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import { isHeaderSelectedForExport } from '@/utils/relatorioExportProfiles';

export default {
    components: {
        MultiplaEscolha,
        MerusDataTable,
        CadastroToolbar,
    },
    data: () => ({
    headers: [],
        user: null,
        token: null,
        formValidado: false,
        linhas: [],
        linhasSelecionadas: [],
        unidades: [],
        unidadesSelecionadas: [],
        itens: [],
        loading: false,
    }),
    computed: {
        unidadesItens() {
            return this.unidades;
        },
        linhasItens() {
            if (!this.linhas.length) {
                return [];
            }
            if (!this.unidadesSelecionadas.length) {
                return this.linhas;
            }
            const set = new Set(this.unidadesSelecionadas.map((id) => Number(id)));
            return this.linhas.filter((l) => {
                const u = Array.isArray(l.unidades) ? l.unidades : [];
                return u.some((id) => set.has(Number(id)));
            });
        },
        defaultSort() {
            return [
                { value: 'cod_linha', options: { text: this.$t('routs.increasing'), value: 1 } }];
        },
        defaultHeaders() {
            const col = (key, value) => ({
                text: this.$t(`relOcupacaoTurno.headers.${key}`),
                value,
                sortable: true,
                filtrable: true,
                show: true,
            });
            return [
                col('lineCode', 'cod_linha'),
                col('lineName', 'nome_linha'),
                col('shift', 'descricao_turno'),
                col('capacity', 'lotacao'),
                col('peopleCount', 'qtd_passageiros'),
                col('percent', 'taxa_ocupacao'),
                col('reservations', 'qtd_reservas'),
                col('predictedCount', 'qtd_ocupacao_prevista'),
                col('predictedPercent', 'taxa_ocupacao_prevista'),
            ];
        },
        tableHeaders() {
            return this.headers.length > 0 ? this.headers : this.defaultHeaders;
        },
        /** CSV/PDF: só colunas oficiais (ignora id_linha/id_turno/id_cliente da API ou do banco). */
        exportHeadersResolved() {
            const allowed = new Set(this.defaultHeaders.map((h) => h.value));
            const source = this.headers.length > 0 ? this.headers : this.defaultHeaders;
            return source.filter(
                (h) =>
                    h &&
                    h.value &&
                    h.value !== 'actions' &&
                    allowed.has(h.value) &&
                    isHeaderSelectedForExport(h)
            );
        },
        /** Mesmo body enviado a getRelatorioocupacaoporturno; reexecutado pelo worker de export CSV. */
        csvExportRequestParams() {
            const params = {};
            if (this.linhasSelecionadas.length) {
                params.id_linhas = this.linhasSelecionadas.map((id) => Number(id));
            }
            if (this.unidadesSelecionadas.length) {
                params.id_unidades = this.unidadesSelecionadas.map((id) => Number(id));
            }
            return params;
        },
    },
    watch: {
        '$i18n.locale'() {
            this.headers = this.defaultHeaders;
            this.initialize();
        },
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.headers = this.defaultHeaders;
        this.initialize();
    },
    methods: {

        initialize() {
            this.populaLinhas();
            this.populaUnidades();
        },
        setDefaultFilters() {
            this.linhasSelecionadas = [];
            this.unidadesSelecionadas = [];
            this.itens = [];
        },
        populaLinhas() {
            apiController.request(apiController.endpoints.getLinhasativas, {
                onSuccess: (response) => {
                    this.linhas = response.data || [];
                }
            });
        },
        populaUnidades() {
            apiController.request(apiController.endpoints.getallUnidadesativas, {
                onSuccess: (response) => {
                    this.unidades = [
                        { id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' },
                        ...(response.data || [])];
                }
            });
        },
        populaRelatorio() {
            this.loading = true;
            const body = {};
            if (this.linhasSelecionadas.length) {
                body.id_linhas = this.linhasSelecionadas.map((id) => Number(id));
            }
            if (this.unidadesSelecionadas.length) {
                body.id_unidades = this.unidadesSelecionadas.map((id) => Number(id));
            }
            apiController.request(apiController.endpoints.getRelatorioocupacaoporturno, {
                data: body,
                onSuccess: (response) => {
                    this.itens = response.data || [];
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                }
            });
        },
    },
};
</script>

<style lang="">
</style>
